module.exports = "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJpbWcvdHdpdHRlci1jYXJkLWltYWdlLnN2Zy4wZTk3MTYyZS5wbmciOw=="